import requestPostResendActivationEmail from 'agentHub/api/requestPostResendActivationEmail'
import ModalBody from 'LuxKit/Modal/ModalBody'
import ModalContent from 'LuxKit/Modal/ModalContent'
import ModalHeader from 'LuxKit/Modal/ModalHeader'
import TextLink from 'LuxKit/TextLink'
import BodyText from 'LuxKit/Typography/BodyText'
import { useAppSelector } from 'hooks/reduxHooks'
import noop from 'lib/function/noop'
import React, { useCallback } from 'react'
import {
  FormattedMessage,
  useIntl,
} from 'react-intl'
import { showSnackbar } from 'LuxKit/Snackbar/AppSnackbar'
import useModalElementContext from 'hooks/Modal/useModalElementContext'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'

interface Props {
  requestedEmail: string
  onModeChange?: (mode: App.UiAccountModalMode) => void
}

function AgentHubResendActivationEmail(props: Props) {
  const {
    requestedEmail,
    onModeChange = noop,
  } = props
  const intl = useIntl()
  const modalContext = useModalElementContext()
  const agentStatus = useAppSelector(state => state.agentHub.agentStatus[requestedEmail])

  const onBack = useCallback(() => {
    onModeChange('login')
  }, [onModeChange])

  const handleResendEmail = useCallback(async() => {
    if (agentStatus?.data?.agentId) {
      await requestPostResendActivationEmail(agentStatus.data.agentId)
      modalContext.resolve()
      showSnackbar(intl.formatMessage({
        id: '3/05DoIweg',
        defaultMessage: 'Activation email sent.',
        description: 'Agent Hub snackbar confirmation after resending activation email',
      }), 'success')
    }
  }, [agentStatus, modalContext, intl])

  return <>
    <ModalHeader
      title={intl.formatMessage({
        id: 'yYfvMJ85kv',
        defaultMessage: 'Finish setting up your account',
        description: 'Agent Hub resend activation email modal title',
      })}
      onBackButtonClick={onBack}
    />
    <ModalBody>
      <ModalContent>
        <VerticalSpacer gap={20}>
          <BodyText variant="large">
            <FormattedMessage
              id="mzyq3plLiY"
              defaultMessage="Your account setup is not yet complete. To continue with your account setup, we have sent an activation email to <bold>{requestedEmail}</bold>.{br}{br}Please check your inbox and follow the instructions provided in the email to continue."
              description="Message explaining account activation is incomplete with instructions to check email"
              values={{
                requestedEmail,
                bold: (chunks) => <b>{chunks}</b>,
                br: <br />,
              }}
            />
          </BodyText>
          {!!agentStatus?.data?.agentId &&
            <BodyText variant="large">
              <FormattedMessage
                id="OgSFcD/7PG"
                defaultMessage="Don’t see the email? <link>Resend the email</link>."
                description="Help text with link to resend the password reset email"
                values={{
                  link: (chunks) => <TextLink onClick={handleResendEmail}>{chunks}</TextLink>,
                }}
              />
            </BodyText>}
        </VerticalSpacer>
      </ModalContent>
    </ModalBody>
  </>
}
export default AgentHubResendActivationEmail
